import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { eventBus } from '../../../../main';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_SET_SEARCH_PARAMS } from '../../../../store/service-book';
import { IServiceBookSearchParams } from '../../../../store/service-book/service-book-state.store';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store'
import { IUserDetails } from '../../../../models/user'
import {UserTemplate} from '../../../../common/enums'

const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component({
  name:'BookServiceSidebar',
  components: {
    'sub-navigation-title': async () => import('@/components/sub-navigation-title/SubNavigationTitle.vue')
  }
})
class BookServiceSidebar extends Vue {

  @ServiceBookStore.Mutation(SERVICEBOOK_SET_SEARCH_PARAMS)
  storeServiceBookSearchParameter: (parameter: IServiceBookSearchParams) => void;

  @ServiceBookStore.Getter count: {free:number, used:number}
  @ServiceBookStore.Getter isLoading: boolean;
  @UserStore.Getter userInfo: IUserDetails
  /**
   *
   */
  dtWidget: {
    key: string,
    totalKey: string,
  }[];
  activeMenu:string

  constructor() {
    super();
    this.activeMenu = 'used'
    this.dtWidget = [
      {
        key: 'used',
        totalKey: 'used',
      },
      {
        key: 'free',
        totalKey: 'free',
      },
    ]
  }

  goTo(key: string) {
    if(!this.isLoading)
    {
      this.activeMenu = key
      this.storeServiceBookSearchParameter({
        free: key === 'free' ? true : false,
        showDetails: key === 'free' ? false : true,
        key:null,
        number:null
      })
      eventBus.$emit('RELOAD_SERVICEBOOK',{})
    }
  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/service-book').default
    }
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  getTotal (key: string) {
    //return this.count[key] > 0 ? `(${this.count[key]})` : null
    return `(${this.count[key]})`
  }
  created () {
    let startTab = this.$route.query.state;
    if(startTab === 'used' || startTab === 'free'){
        this.activeMenu = startTab
    }
    if(this.isServiceBookOwner){
      this.dtWidget = [
        {
          key: 'used',
          totalKey: 'used',
        }]
    }
  }

}

export default BookServiceSidebar;



// WEBPACK FOOTER //
// ./src/containers/service-book/components/sidebar/index.ts